<template>
  <div class="typicalParamConfiguration">
    <el-card class="box-card" shadow="never">
      <el-button icon="el-icon-back" v-if="active !== -1" style="float: left;" type="primary" @click="setActive">返回</el-button>
      <div v-show="active === -1">
        <div class="excel-button">
          <el-button icon="el-icon-upload2" type="primary" @click="openUploadDialog">导入EXCEl</el-button>
          <el-button icon="el-icon-download" type="primary" @click="openDownloadDialog">导出模版</el-button>
        </div>
        <el-table :data="tableData" ref="tbl" border max-height="600" style="width: 100%; margin-top: 20px;" tooltip-effect="dark">
          <el-table-column type="index" label="序号" width="140" fixed></el-table-column>
          <el-table-column prop="dictOptionName" label="设备类型" fixed show-overflow-tooltip></el-table-column>
          <el-table-column prop="updateTime" label="更新时间"></el-table-column>
          <el-table-column prop="operator" label="配置人"></el-table-column>
          <el-table-column fixed="right" label="操作" align="center">
            <template slot-scope="{ row }">
              <el-button class="btn" type="text" size="small" @click="toEquipTypeDetail(row)">详情</el-button>
              <el-button class="btn" type="text" size="small" @click="toEquipTypeParamsConfig(row)">配置</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <TypicalParamDetail v-if="active === 0" :equipType="equipType" :dictOptionName="dictOptionName" :isType="isType"></TypicalParamDetail>
    </el-card>
    <Dialog ref="uploadDialog" :closeOnClickModal=false title="导入设备典型参数">
      <el-form ref="excelImportForm" :model="excelImportForm" :rules="rules">
        <el-form-item label="设备类型" prop="optionType">
          <el-select v-model="excelImportForm.optionType" style="width: 240px">
            <el-option v-for="item in equipTypeOptions" :key="item.optionType" :label="item.optionName" :value="item.optionType"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="clearfix">
        <el-upload ref="upload" action="" class="upload-demo"
                   :multiple="false"
                   accept=".xlsx"
                   :on-change="handleChange"
                   :before-upload="handleUpload"
                   :limit="1">
          <el-button size="small" type="primary">选择文件</el-button>
          <div slot="tip" class="el-upload__tip">只能上传 xlsx 文件（须解密）！</div>
        </el-upload>
      </div>
      <div style="margin-top: 20px">
        <li v-for="file in fileList" :key="file.id">{{ file.name }}</li>
      </div>
      <div class="excel-import-button">
        <el-button type="primary" @click="confirmUpload">导入</el-button>
        <el-button type="primary" @click="cancelUpload">取消</el-button>
      </div>
    </Dialog>
    <Dialog ref="downloadDialog" title="导出设备典型参数模版">
      <el-form ref="excelExportForm" :model="excelExportForm" :rules="rules">
        <el-form-item label="设备类型" prop="optionType">
          <el-select v-model="excelExportForm.optionType" style="width: 240px">
            <el-option v-for="item in equipTypeOptions" :key="item.optionType" :label="item.optionName" :value="item.optionType"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="excel-export-button">
        <el-button type="primary" @click="confirmDownload">下载</el-button>
        <el-button type="primary" @click="cancelDownload">取消</el-button>
      </div>
    </Dialog>
  </div>
</template>

<script>
  import TYPICALPARAMAPI from '@/api/typicalParam';
  import DATADICTIONARYAPI from '@/api/dataDictionary';
  import Dialog from '@/components/dialog';
  import TypicalParamDetail from './typicalParamDetail';

  export default {
    components: {
      Dialog,
      TypicalParamDetail
    },
    data() {
      return {
        active: -1,                       // -1-典型参数列表页、0-编辑页、详情页
        isType: 'edit',                   // edit-编辑、detail-详情

        tableData: [],
        equipTypeOptions: [],             // 设备类型选项

        // 详情页
        equipType: -1,                    // 设备类型id
        dictOptionName: '',               // 设备类型描述

        // 下载
        excelExportForm: {
          optionType: '',
        },
        downloadEquipType: -1,            // 下载参数-设备类型id

        // 导入
        file: [],                         // 上传文件-作为参数传后端
        fileList: [],                     // 上传文件列表-展示用
        excelImportForm: {
          optionType: '',
        },

        rules: {
          optionType: [{
            required: true,
            message: '请选择设备类型',
            trigger: 'blur'
          }]
        },
      };
    },
    computed: {},
    methods: {

      setActive() {
        this.active = -1;
        this.selectEquipTypicalParamInfoList();
      },

      // 查询字字典表列表
      selectEquipTypicalParamInfoList() {
        TYPICALPARAMAPI.selectEquipTypicalParamInfoList().then(res => {
          if (res.data.code === 200 && !res.data.errors) {
            this.tableData = res.data.data;
            console.log(this.tableData)
            this.$nextTick(function () {
              this.$refs.tbl.doLayout();
            });
          }
          if (res.data.errors) {
            this.$message.error(res.data.errors);
          }
        });
      },

      // 查询设备类型
      searchDictOptionListByDictInfoId() {
        let params = {
          dictInfoId: 1
        };
        let self = this;
        DATADICTIONARYAPI.searchDictOptionListByDictInfoId(params).then(res => {
          if (res.data.code === 200 && !res.data.errors) {
            this.equipTypeOptions = res.data.data.filter(item => item.status === 0)
              .map(item => {
                return {
                  optionName : item.optionName,
                  optionType : item.optionType,
                }
              });
            this.$nextTick(function () {
              self.$refs.tbl.doLayout();
            });
          }
          if (res.data.errors) {
            this.$message.error(res.data.errors);
          }
        });
      },

      // 导出模版
      openDownloadDialog() {
        this.$refs.downloadDialog.open();
      },

      // 导出模版-下载
      confirmDownload() {
        const params = {
          equipType: this.excelExportForm.optionType
        };
        let equipName = '';
        const foundItem = this.equipTypeOptions.find(item => item.optionType === this.excelExportForm.optionType);
        if (foundItem) {
          equipName = foundItem.optionName;
        }
        if (equipName === '') {
          equipName ='未命名';
        }
        this.$refs.excelExportForm.validate(valid => {
          if (valid) {
            TYPICALPARAMAPI.exportEquipTypicalParamListByEquipType(params).then(res => {
                const data = res.data;
                const xlsx = 'application/vnd.ms-excel';
                const blob = new Blob([data], { type: xlsx });
                const a = document.createElement('a');
                a.download = equipName + '_典型参数模板.xlsx';
                a.href = window.URL.createObjectURL(blob);
                a.click();
                a.remove()
              });
            this.$refs.downloadDialog.close();
            }
        });
      },

      // 导出模版-取消
      cancelDownload() {
        this.$refs.downloadDialog.close();
      },

      // 上传文件 - 弹窗
      openUploadDialog() {
        this.$refs.uploadDialog.open();
      },

      // 上传文件 -
      handleChange(file) {
      },

      // 上传文件 -
      handleUpload(file) {
        this.fileList = [
          {name: file.name}
        ];
        this.file = file;
      },

      // 上传文件 - 导入
      confirmUpload: function () {
        const formdata = new FormData();
        formdata.append('file', this.file);
        formdata.append('equipType', this.excelImportForm.optionType);
        TYPICALPARAMAPI.importEquipTypicalParamListByEquipType(formdata).then(res => {
          if (res.data.code === 200) {
            this.$message.success('导入成功');
          }
        }).catch((e) => {
          console.log(e)
        });
        this.fileList = [];
        this.file = [];
        this.$refs.uploadDialog.close();
      },

      // 上传文件- 取消
      cancelUpload() {
        this.fileList = [];
        this.file = [];
        this.$refs.uploadDialog.close();
      },

      // 详情
      toEquipTypeDetail(row) {
        this.isType = 'detail';
        this.active = 0;
        this.equipType = row.equipType;
        this.dictOptionName = row.dictOptionName;
      },
      // 配置
      toEquipTypeParamsConfig(row) {
        this.isType = 'edit';
        this.active = 0;
        this.equipType = row.equipType;
        this.dictOptionName = row.dictOptionName;
      },
    },

    created() {
      this.selectEquipTypicalParamInfoList();                 // 获取典型参数列表
      this.searchDictOptionListByDictInfoId();                // 获取设备类型
    }
  };
</script>

<style lang="scss" scoped>
  .typicalParamConfiguration {
    .box-card {
      .excel-button {
        display: inline;
        text-align: left;
        > div {
          display: inline-block;
        }
      }

      .text-btn {
        padding: 0 20px;
        font-size: 12px !important;

        &span {
          font-size: 12px !important;
        }
      }

      .btn-tools {
        text-align: center;
        margin-top: 35px;

        .btn {
          width: 100px;
        }
      }
    }

    .excel-import-button {
      text-align: center;
      margin-top: 50px;
    }

    .excel-export-button {
      text-align: center;
      margin-top: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/boss/typicalParamConfiguration/index.vue